module.exports = __webpack_public_path__ + "static/media/IMG_7270-min.f3bb6347.jpg";